import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { background } from './tempests.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/220601/tempests-le_dr3/tempests-le_dr3_{nnn}.png',
}

export default {
  layers: [background, body],
  resolveOptions: () => ({}),
}
